module.exports = __webpack_public_path__ + "static/img/5654_phase_function_Paper_PointsHejduk_Prediction.f63f7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5654_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2jRv
// module chunks = 0